import React from 'react'
import { Job, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizardMobile.SiteVisitTime = {
  onSubmit: function(onStepProgression, onRequest, onRequestCompletion, onStepRetreat) {
    if (Job.Data.backToSubmit === true) {
      JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.JobSummary)
    }
    else {
      onStepProgression()
    }
  },

  onLeftNavButtonClick(onStepProgression) {
    $('.choose-site-visit-time').addClass('hidden')
    $('#job-modal').data('bootstrapValidator').removeField('site_visit_time')
    JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.ChooseSiteVisit)
  },

  component: React.createClass({
    getInitialState: function() {
      const job = Job.Data;

      return {
        siteVisitTime: job.siteVisitTime
      }
    },

    componentDidMount: function() {
      if (Job.Data.siteVisit === "no_site_visit_required" || Job.Data.siteVisit === "anytime") {
        this.props.onStepProgression()
      }

      $('#job-modal').bootstrapValidator({ /* */ })
      this.validator = $('#job-modal').data('bootstrapValidator')
      $('#site-visit-time').radioButtonGroup({activeRowClass: 'active'})

      this.componentDoesValidate()
    },

    autoProgress: function() {
      if (Job.Data.backToSubmit === true){
        JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.JobSummary)
      }
      else {
        this.props.onStepProgression()
      }
    },

    siteVisitTimeChanged: function(e) {
      Job.Actions.updateSiteVisitTime(e.currentTarget.querySelector('[type="radio"]').value)
      this.retestValidationsToRemoveErrorsOn('site_visit_time')
      this.autoProgress()
    },

    validator: undefined,

    retestValidationsToRemoveErrorsOn: function(fieldName) {
      this.validator.$form.data('bootstrapValidator').revalidateField(fieldName)
    },

    componentDoesValidate: function() {
      const validator = this.validator;
      validator.addField('site_visit_time',
        {
          validators: {
            notEmpty: {
              message: 'Please choose a "Preferred Time"'
            }
          }
        }
      )
    },

    render: function() {
      let radioButtonVisible = "col-xs-2 col-sm-2 circle"
      let radioButtonHidden  = `${radioButtonVisible} hidden`

      return (
        <div>
          <div className="form-group choose-site-visit-time" onClick={this.autoProgress}>
            <h3 className="mb15 mt15">Preferred Time?</h3>
            <div className="radio-button-box minor-bold" id="site-visit-time">
              <div className="radio" onClick={this.siteVisitTimeChanged}>
                <div className="row">
                  <div className="col-xs-10 col-sm-10" id='business-hours'>Business Hours</div>
                  <input type="radio" name="site_visit_time" value="business-hours" className="form-control invisible" />
                </div>
              </div>
              <div className="radio" role="tab" onClick={this.siteVisitTimeChanged}>
                <div className="row">
                  <div className="col-xs-10 col-sm-10">Evenings 5pm Onwards</div>
                  <input type="radio" name="site_visit_time" value="evenings" className="form-control invisible" />
                </div>
              </div>
              <div className="radio" onClick={this.siteVisitTimeChanged}>
                <div className="row">
                  <div className="col-xs-10 col-sm-10">Anytime</div>
                  <input type="radio" name="site_visit_time" value="anytime" className="form-control invisible" />
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
  })
}
